export interface ExperienceFilter {
  min: number;
  max: number;
}

export const DEFAULT_EXPERIENCES_VALUE: ExperienceFilter = {
  min: 0,
  max: 50,
};

export class ExperienceFilterAdapter {
  min: number;
  max: number;

  constructor(min: number, max: number);
  constructor(values: number[] | ExperienceFilter);
  constructor(values?: number | number[] | ExperienceFilter, min?: number, max?: number) {
    if (instanceOfExperienceFilter(values)) {
      this.min = values.min;
      this.max = values.max;
    } else if (values instanceof Array) {
      this.min = values[0];
      this.max = values[1];
    } else {
      this.min = min;
      this.max = max;
    }
  }

  toArray(): number[] {
    return [this.min, this.max];
  }

  toExperienceFilter(): ExperienceFilter {
    return {
      min: this.min,
      max: this.max,
    };
  }
}

export const isDefaultExperienceFilter = (filter: ExperienceFilter): boolean => {
  const { min: filterMin, max: filterMax } = filter;
  const { min: defaultMin, max: defaultMax } = DEFAULT_EXPERIENCES_VALUE;
  return !!filter && filterMin === defaultMin && filterMax === defaultMax;
};

function instanceOfExperienceFilter(object: any): object is ExperienceFilter {
  return !!object && 'min' in object && 'max' in object;
}
